import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';
import { useScrollReveal } from '../hooks/useScrollReveal';

export default function AnimatedSection({ children, variants = fadeInUp, className = '', as = 'div', ...props }) {
  const [ref, isVisible] = useScrollReveal();
  const Component = motion[as] || motion.div;

  return (
    <Component
      ref={ref}
      initial="hidden"
      animate={isVisible ? 'visible' : 'hidden'}
      variants={variants}
      className={className}
      {...props}
    >
      {children}
    </Component>
  );
}
